import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  inject, observer,
} from 'mobx-react';
import React from 'react';
import {
  ThemePalette,
} from 'theme/types';
import {
  IAuthStore,
} from '../../../mobx-store/storeInterfaces/authInterface';
import NavigationItem from './NavigationItem/NavigationItem';
import classes from './NavigationItems.module.scss';
import {
  routesTable,
} from './routes.js';

interface IProps {
  authStore?: IAuthStore;
}

interface State {
  openAcademies: boolean;
  openDeglawy: boolean;
  openHome: boolean;
  openBranches: boolean;
  openNews: boolean;
  openAds: boolean;
  menuStatus: any[];
}

@inject('authStore')
@observer
class NavigationItems extends React.Component<IProps, State> {
  authStore: any;

  constructor(props: IProps, state: State) {
    super(props);
    this.authStore = this.props.authStore;
    this.state = {
      openAcademies: false,
      openDeglawy: false,
      openHome: false,
      openBranches: false,
      openNews: false,
      openAds: false,
      menuStatus: routesTable.map(() => false),
    };
  }

  handleClick(index: number) {
    this.setState({
      menuStatus: this.state.menuStatus.map((menu, i) => {
        if (index === i) {
          return !menu;
        }
        return false;
      }),
    });
  }

  render() {
    return (
      this.props.authStore!.userData.role.title.length > 0
        ? (
          <ul className={classes.NavigationItems}>
            {
              routesTable.map((route, index) => {
                if (route.allowedUsers.indexOf(this.props.authStore!.userData.role.title) >= 0) {
                  if (route.children) {
                    return (
                      <List key={index}>
                        <ListItem button onClick={() => this.handleClick(index)} className={classes.ListItemPadding}>
                          <ListItemIcon
                            className={classes.customIcon}
                          >
                            {route.icon}
                          </ListItemIcon>
                          <ListItemText inset primary={route.label} className={classes.listItemText} />
                          {this.state.menuStatus[index] ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.menuStatus[index]} timeout="auto" unmountOnExit>
                          <List>
                            {
                              route.children.map((childRoute: any, key: number) => {
                                if (!childRoute.allowedUsers) {
                                  return (
                                    <NavigationItem link={childRoute.path} key={key}>
                                      <ListItem button className={classes.spaceLeft}>
                                        <Typography variant="subtitle1" gutterBottom color="textPrimary">
                                          {childRoute.label}
                                        </Typography>
                                      </ListItem>
                                    </NavigationItem>
                                  );
                                } if (childRoute.allowedUsers && childRoute.allowedUsers.indexOf(this.props.authStore!.userData.role.title) >= 0) {
                                  return (
                                    <NavigationItem link={childRoute.path} key={key}>
                                      <ListItem button className={classes.spaceLeft}>
                                        <Typography variant="subtitle1" gutterBottom color="textPrimary">
                                          {childRoute.label}
                                        </Typography>
                                      </ListItem>
                                    </NavigationItem>
                                  );
                                }
                                return null;
                              })
                            }
                          </List>
                        </Collapse>
                      </List>
                    );
                  }
                  return (
                    <NavigationItem link={route.path} exact key={index}>
                      <div className={classes.bar}>
                        <div className={classes.customIcon}>
                          {route.icon}
                        </div>
                        <Typography className={classes.barTitle} variant="subtitle1" gutterBottom color="textPrimary">
                          {route.label}
                        </Typography>
                      </div>
                    </NavigationItem>
                  );
                }
              })
            }
            <li>
              <Button
                variant="contained"
                size="small"
                color="primary"
                style={{
                  margin: '10px', padding: '10px 20px', textAlign: 'center', fontWeight: 'bolder',
                }}
                onClick={() => this.props.authStore!.logout()}
              >
                LOG OUT
              </Button>
            </li>
          </ul>
        )
        : null
    );
  }
}

export default NavigationItems;
